import script from "./TheModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheModal.vue?vue&type=script&lang=ts&setup=true"

import "./TheModal.vue?vue&type=style&index=0&id=5a769b5c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a769b5c"]])

export default __exports__